export default "__VITE_ASSET__D5wf2SNd__"